import { gql } from '@apollo/client';

export default gql`
  mutation UpdateIssue($input: UpdateIssueInput!) {
    updateIssue(input: $input) {
      id
    }
  }
`;
